// Add note in cart
class CartNote extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keydown', debounce((event) => {
            console.log("event", event.target.value);
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
    }
}

customElements.define('cart-note', CartNote);



var selectOption = $('.product-form__input .form__select .select__select option.unavailable');
  // console.log("selectOption", selectOption);

for (var i = 0; i < selectOption.length; i++) {
  var item = selectOption[i];
    item.disabled = true;
}

let items1 = $(".alertBox--info.tag-pre-order")[0];
let items2 = $(".alertBox--info.tag-Featured")[0];

$(items1).css("display", "block")
$(items2).css("display", "block")


